import React, {useEffect} from 'react';
import {Container, Row, Col} from 'reactstrap';
import img from "../../../assets/images/demos/komp1.png";
import computer from "../../../assets/images/app/computer.png";
import {useTranslation} from 'react-i18next';
import {appConfig} from '../../../config';

const Connect3 = () => {
    const {t} = useTranslation();

    const toTop = () => {
        document.body.scrollTop = 0;
        document.documentElement.scrollTop = 0;
    };

    useEffect(() => {
        toTop();
    }, []);

    return (
        <React.Fragment>
            <section className="section" id="wallet">
                <Container>
                    <Row className="justify-content-center">
                        <Col lg={6} className='pe-1 pe-5'>
                            <div className="text-start mb-5">
                                <h2 className="mb-3 lh-base text-capitalize">
                                    {t('t-salary-advantages-head').replace('{appName}', appConfig.appName)}
                                </h2>
                                <p className="text-muted">
                                    {t('t-salary-advantages-desc')}
                                </p>
                                <div className="vstack gap-2">
                                    <div className="d-flex align-items-start">
                                        <div className="flex-shrink-0 me-2">
                                            <div className="avatar-xs icon-effect">
                                                <div
                                                    className="avatar-title bg-transparent text-success rounded-circle h2">
                                                    <i className="ri-check-fill"></i>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="flex-grow-1">
                                            <p className="mb-0">
                                                {t('t-salary-advantages1')}
                                            </p>
                                        </div>
                                    </div>
                                    <div className="d-flex align-items-start">
                                        <div className="flex-shrink-0 me-2">
                                            <div className="avatar-xs icon-effect">
                                                <div
                                                    className="avatar-title bg-transparent text-success rounded-circle h2">
                                                    <i className="ri-check-fill"></i>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="flex-grow-1">
                                            <p className="mb-0">
                                                {t('t-salary-advantages2')}
                                            </p>
                                        </div>
                                    </div>
                                    <div className="d-flex align-items-start">
                                        <div className="flex-shrink-0 me-2">
                                            <div className="avatar-xs icon-effect">
                                                <div
                                                    className="avatar-title bg-transparent text-success rounded-circle h2">
                                                    <i className="ri-check-fill"></i>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="flex-grow-1">
                                            <p className="mb-0">
                                                {t('t-salary-advantages3')}
                                            </p>
                                        </div>
                                    </div>
                                    <div className="d-flex align-items-start">
                                        <div className="flex-shrink-0 me-2">
                                            <div className="avatar-xs icon-effect">
                                                <div
                                                    className="avatar-title bg-transparent text-success rounded-circle h2">
                                                    <i className="ri-check-fill"></i>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="flex-grow-1">
                                            <p className="mb-0">
                                                {t('t-salary-advantages4')}
                                            </p>
                                        </div>
                                    </div>
                                    <div className="d-flex align-items-start">
                                        <div className="flex-shrink-0 me-2">
                                            <div className="avatar-xs icon-effect">
                                                <div
                                                    className="avatar-title bg-transparent text-success rounded-circle h2">
                                                    <i className="ri-check-fill"></i>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="flex-grow-1">
                                            <p className="mb-0">
                                                {t('t-salary-advantages5')}
                                            </p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </Col>
                        <Col lg={6}>
                            <div className="text-center mb-5">
                                <img src={computer} alt="" className="img-fluid"/>
                            </div>
                        </Col>
                    </Row>
                </Container>
            </section>
        </React.Fragment>
    );
}

export default Connect3;